import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../../types/store';
import { getModuleMeta } from '../../client/selectors/modules';
import { updateModule } from '../../client/actions/modules';

export const useModuleMeta = (moduleId: number) => {
  const dispatch = useDispatch();
  const moduleMeta = useSelector((state: AppState) =>
    getModuleMeta(state, moduleId)
  );

  const updateModuleMeta = useCallback(
    meta => dispatch(updateModule({ id: moduleId, moduleMeta: meta })),
    [dispatch, moduleId]
  );
  return { moduleMeta, updateModuleMeta };
};

export default useModuleMeta;
